import * as React from 'react';
import { MutationFunc, ApolloConsumer } from 'react-apollo';
import gql from 'graphql-tag';

export interface IAdyenFormProps {
  createPayment: MutationFunc;
  variables: any;
}

export interface IAdyenFormState {
  adyenLoaded: boolean;
  paymentSession: any;
}

const PaymentStateQuery = gql`
  query checkPaymentState($orderNumber: String!, $payload: String!, $paymentId: String!) {
    checkPaymentState(payment: {
      orderNumber: $orderNumber
      payload: $payload
      paymentId: $paymentId
    })
    {
      code
    }
  }
`;

class AdyenForm extends React.Component<IAdyenFormProps, IAdyenFormState> {

  public state: IAdyenFormState;

  constructor(props: IAdyenFormProps) {
    super(props);

    this.state = {
      adyenLoaded: false,
      paymentSession: null,
    };
  }

  public componentDidMount() {
    if (
      window !== undefined &&
      (window as any).paypal === undefined
    ) {
      this.loadAdyen();
      this.createPayment();
    }

  }

  public render() {
    const { adyenLoaded, paymentSession } = this.state;

    if (!adyenLoaded && (window as any).chckt === undefined) {
      console.log('adyen not detected');
      return null;
    }

    if (!paymentSession) {
      console.log('payment session not received');
      return null;
    }

    const config = {
      context: 'test' // 'live'
    };
    const checkout = (window as any).chckt.checkout(paymentSession, '#adyen-form', config);

    return (
      <ApolloConsumer>
        {client => {
          (window as any).chckt.hooks.beforeComplete = async (node: any, paymentData: any) => {
            // TO-DO: poslat payload na server pro verifikaci platby
            const { payload } = paymentData;
            const data = await client.query({
              query: PaymentStateQuery,
              variables: {
                orderNumber: this.props.variables.variables.orderNumber,
                payload,
                paymentId: paymentSession
              }
            });
            window.location.href = window.location.href;
            return false;
          };
          return <div />;
        }}
      </ApolloConsumer>
    );
  }

  private loadAdyen() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://checkoutshopper-test.adyen.com/checkoutshopper/assets/js/sdk/checkoutSDK.1.9.2.min.js`;
    script.async = true;
    script.onload = () => {
      this.setState({ adyenLoaded: true });
    };
    script.onerror = () => {
      throw new Error('Adyen SDK could not be loaded.');
    };

    document.body.appendChild(script);
  }

  private async createPayment() {
    const result = await this.props.createPayment(this.props.variables);
    if (result.data && result.data.createPayment.code) {
      this.setState({
        paymentSession: result.data.createPayment.code
      });
    }
    return null;
  }
}

export default AdyenForm;


// WEBPACK FOOTER //
// ./src/components/GatewayComponent/AdyenForm.tsx